import { render, staticRenderFns } from "./PaymentsIntegrationsList.vue?vue&type=template&id=d4076d98&"
import script from "./PaymentsIntegrationsList.vue?vue&type=script&lang=js&"
export * from "./PaymentsIntegrationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports